// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
let url = ""

if(window.location.href.includes('172.20.8.91:8004')){//PROD
  url = 'http://172.20.8.91:8005' //PROD

}else if(window.location.href.includes('172.20.8.91:8014')){//HOMOL

  url = 'http://172.20.8.91:8015' //HOMOL

}else if(window.location.href.includes('172.20.8.92:8004')){//HOMOL

  url = 'http://172.20.8.92:8005' //HOMOL

}else if(window.location.href.includes('localhost')){
  url = 'http://localhost:8005'

}else if(window.location.href.includes('http://10.129.0.199:8007')){//PROD AWS

  url = 'http://10.129.0.199:8008' //PROD AWS

}else if(window.location.href.includes('dm-pluris') && window.location.href.includes('8014')){

  url = 'http://easyqualitybackend.dm-pluris.plurismidia.com.br:8015' //HOMOL
}else if(window.location.href.includes('dm-pluris') && window.location.href.includes('8007')){
  
  url = 'http://easyqualitybackend.dm-pluris.plurismidia.com.br:8008'

}else if(window.location.href.includes('dm-pluris')){

  url = 'http://easyqualitybackend.dm-pluris.plurismidia.com.br:8005' //PROD OCI
  
}else{

  url = 'https://easyqualitybackend.plurismidia.com.br' //PROD
}



export const environment = {

  production: false,




  //ACESSOS DA APLICAÇÃO CADASTRADOS NO BACKEND (SPRING BOOT)
  urlBackend: url, // TESTES LOCAIS
  //urlBackend: 'http://172.20.8.91:8005', // TESTES LOCAIS
  clientId: 'portal-pluris-quality',
  clientSecret: 'PLURIS_oiuUYILlkjoYoamnGfgakPsgusadPIShgjasdasdj678fgJf',

  //CHAMADAS (SEVIÇOS BACKEND SPRING BOOT)
  //POST s
    obterTokenURL:  '/oauth/token', //AUTENTICAÇÃO (OATH2 + JWT)
    cadastrarUsuario: '/api/usuario/create', //CADASTRA FUNCIONARIOS
    criarFormulario: '/form',
    criarCabecalho: '/parameter',
    criarMotivo: '/motive',
    criarParametroMotivo: '/motiveparameter',
    criarGrupoCategoria: '/category-group',
    criarCategoria: '/category',
    criarPergunta: '/question',
    criarResposta: '/answer',
    criarPergXResp: '/question-answer',
    criarMonitoria: '/monitory',
    criaContestacao: '/contestation',
    criaRespostaContestacao: '/contestation-answer',
    updateContestacao: '/contestation/',


    criateUpdateMonitoriaParametro: '/monitoryparameter',

    criaMonitoriaPergResp: '/monitory-question-answer',
    criaMonitoriaPergRespList: '/monitory-question-answer/list/',
    criaMotiveParameterMoni : '/motiveparametermoni' ,
    getMotiveParameterMoniByPamo : '/motiveparametermoni/getbymonitoryparameter/' ,

    updateMonitoria: '/monitory',
    nrPoitsMonitoriaSoma: '/question-answer/points/',
    nrPoitsMonitoriaMedia: '/question-answer/pointsmedia/',
    nrExtraPoitsMonitoria: '/question-answer/pointsextra/',
    nrZeradosGraveMonitoria: '/question-answer/zeradosgrave/',
    nrZeradosNaoGraveMonitoria: '/question-answer/zeradosnaograve/',

    login: '/user/login',
    loginAuthenticator: '/user/authenticator',


    criarOperacao: '/operation',
    updateOperacao: '/operation',
    listarCadastroOperacoes: '/operation/list',
    listarCadastroOperacoesAtivos: '/operation/list/active',
    listarUsuariosOperacoes: '/user/operacao',
    listarAllUsuariosOperacoes: '/user/all-operacao',
    listarCadastroMenusAtivos: '/menu/list/active',
    listarPlanosDeAcoesPorEmpresa: '/actionplan/operacao',
    criarActionplan: '/actionplan/newactionplan',
    updatActionplan: '/actionplan/update',
    listarStatusPlanosDeAcoes: '/actionplanstats/getallactive',
    listarMeses: '/month/getallactive',
    listarParecer:'/seem/getall',
    updateSeem: '/seem/update',
    criarSeem: '/seem/newseem',
    inativarActionplan: '/actionplan/inativeActionPlan',



    criarUsuario: '/user/newuser',
    updateUsuario: '/user/updateuser',
    getUsuario: '/user/re',
    getUsuarioById: '/user',
    listarSituacaoPorOperacoes: '/user-situation/list',
    listarTipoUsuario: '/user-type/list',
    criarEmpresaPorUsuario: '/useroperation/newuseroperation',
    deletarUsuarioPorOperacao: '/useroperation/deleteuseroperation',

    getUsuarioByName: '/user/getbyname',
    getTempoUsuarioOperacao: '/user/tempooperacional/',
    getExport: '/export',

    listarGertorPorEmpresa: '/user/gestoresativosoperacao',
    listarAssistentePorOperacaoGestor:  '/user/userbyoperationgestor',

    listarMonitorias:  '/monitory/list',
    listarMonitoriasFiltradas:  '/monitory/filters',
    listarMonitoriaById:  '/monitory/withgestor',


    criarUsuarioPorEmpresa: '/useroperation/newuseroperation',
    criarUsuarioPorMenu: '/permission',
    deletarUsuarioPorMenu: '/permission/delete',
    deletarParametroXMotivo: '/motiveparameter/delete',
    deletarPergXRep: '/question-answer/delete',



    resetPassword: '/password/reset',
    listarFormulariosOperacao: '/form/all-operacao',
    listarFormulariosOperacaoSemPerguntas: '/form/all-operacao/withoutquestions',
    listarFormulariosOperacaoFicha: '/form/all-operacao-ficha',
    listarFormularioEspecifico: '/form',
    listarFormularioEspecificoSemPerguntas: '/form/withoutquestions',
    listarParametersByForm: '/getallactivesbyform/',
    listarResposta: '/answer/getidbyform/',
    listarCabecalho: '/parameter/getidbyform/',
    listarMotivo: '/motive/getbyform/',
    listarParametroXMotivo: '/motiveparameter/getbyform/',
    listarGrupo: '/category-group/getidbyform/',
    listarCategoria: '/category/getidbyform/',
    listarFormulario: '/form/getformbyid/',
    listarFormularioPossuiMonitoria: '/form/getformfrommonitory/',
    listarPerguntas: '/question/getidbyform/',
    listarCategoriaPorGrupo: '/category/getcategorybygroup/',
    listarPergXResp: '/question-answer/listbyform/',
    listaPerguntaCategoria: '/question/getidbycategory/',
    carregaMonitoria: '/monitory/active/',
    carregaMonitoriaWithoutQuestions: '/monitory/active/withoutquestions/',
    carregaPontosPorGrupoCategoria: '/monitory/pointsbygroupcategory/',
    carregaMonitoriabyRe: '/monitory/re',

    atualizaMonitoryQuestionAnswer: '/monitory-question-answer/',
    getPergunta: '/question/',
    getResposta: '/answer/',
    getConfiguracaoPorGrupo: '/configuration/list/grupoconfig/',
    getConfiguracaoPorChave: '/configuration/chave/',


    getContestacao: '/contestation/',
    getRespostaContestacao: '/contestation-answer/',
    geraGravacaoPorMonitoria: '/recording',
    saveDestinatario: '/destinatarios',

  //PUT
    atualizarUsuario: '/api/usuario/', //UPDATE CADASTRO
    atualizarConfiguracao: '/api/configuracao/0', //UPDATE CADASTRO
    atualizarFormulario: '/form/',
    atualizarCabecalho: '/parameter/',
    atualizarMotivo: '/motive/',
    atualizarParameterXMotivo: '/motiveparameter/',
    atualizarGrupoCategoria: '/category-group/',
    atualizarCategoria: '/category/',
    atualizarPergunta: '/question/',
    atualizarResposta: '/answer/',
    atualizaPergXResp: '/question-answer/',
    atualizaFeedback: '/monitory/feedback/',
    atualizaDestinatario: '/destinatarios/',




  //PROFILE
  listarProfiles: '/profile/list',
  listarProfilesAtivos: '/profile/list/active',
  getProfile: '/profile/',
  updateProfile: '/profile/',
  criarProfile: '/profile',

  //STATUS
  listarStatus: '/status/list',
  listarStatusAtivos: '/status/list/active',
  getStatus: '/status/',
  updateStatus: '/status/',
  criarStatus: '/status',

  //STATUSMONITORY
  getAllStatusMonitoryByIdMonitory: '/statusmonitory/bymonitory/',
  deleteStatusMonitoryById: '/statusmonitory/',
  criarStatusMonitory: '/statusmonitory/',

  listarJustificativa: '/justification/list',
  listarJustificativasAtivas: '/justification/list/active',
  getJustificativa: '/justification/',
  updateJustificativa: '/justification/',
  criarJustificativa: '/justification',

  //MONITORYFILES
  anexarArquivoMonitoria: '/monitoryFiles',
  buscarArquivoMonitoria: '/monitoryFiles/list/',
  buscarNomeArquivoMonitoria: '/monitoryFiles/name/list/',
  downloadArquivoMonitoria: '/monitoryFiles/',
  deletarArquivoMonitoria: '/monitoryFiles/delete/',

  //ACTIONPLANFILES
  anexarArquivoPlanoDeAcao: '/actionPlanFiles',
  buscarArquivoPlanoDeAcao: '/actionPlanFiles/list/',
  buscarNomeArquivoPlanoDeAcao: '/actionPlanFiles/name/list/',
  downloadArquivoPlanoDeAcao: '/actionPlanFiles/',
  deletarArquivoPlanoDeAcao: '/actionPlanFiles/delete/',

  //MONITORYCOMMENTREPLY
  getComment: '/monitory-comment-reply/',
  updateComment: '/monitory-comment-reply/',
  getUserComment:'/user/',
  criarComment: '/monitory-comment-reply',

  //REGULAR APPRAISER
  regularAppraiser: '/regularappraiser',
  getById: '/',
  getAll: '/list',
  getByIdMonitory: '/bymonitory/',

  //MONITORY-EXCLUSION
  solicitarExclusaoFicha: '/monitory-exclusion',
  listarExclusoesPendentes: '/monitory-exclusion/list',

  //LOGS
  createLog: '/logs/newlog',

  //DESTTYPE
  getAllActive: '/desttype/list/active',

  //LIMPAR TABELAS DE * PROCESSO DUPLICAR FORMULARIO
  duplicateFormDropList :  '/duplicationform/limpartabelasdepuplicarformulario',
  
  //DUPLICAR NOVO FORMULARIO * PROCESSO DUPLICAR FORMULARIO
  duplicateFormAll :  '/duplicationform/duplicarformularioCompleto/',

  //DUPLICAR NOVO FORMULARIO * PROCESSO DUPLICAR FORMULARIO
  duplicateForm :  '/duplicationform/duplicarformulario/',

  //DUPLICAR NOVOS GRUPOS DE CATEGORIAS * PROCESSO DUPLICAR FORMULARIO
  duplicaCriarGruposCategorias :  '/duplicationform/criarGruposCategroria/',

  //DUPLICAR NOVAS CATEGORIAS * PROCESSO DUPLICAR FORMULARIO
  duplicaCriarCategorias :  '/duplicationform/criarCategroria/',

  //DUPLICAR NOVAS PERGUNTAS * PROCESSO DUPLICAR FORMULARIO
  duplicateCriarPerguntas :  '/duplicationform/criarPergunta/',
  
  //DUPLICAR NOVAS RESPOSTAS * PROCESSO DUPLICAR FORMULARIO
  duplicaCriarRespostas :  '/duplicationform/criarResposta/',

  //DUPLICAR MOTIVOS DE PARAMETROS * PROCESSO DUPLICAR FORMULARIO
  duplicaMotivosParametros :  '/duplicationform/criarmotivosparametros/',

  //DUPLICAR MOTIVOS DE PARAMETROS * PROCESSO DUPLICAR FORMULARIO
  duplicarParametros :  '/duplicationform/criarparametros/',


  //DUPLICAR MOTIVOS DE PARAMETROS * PROCESSO DUPLICAR FORMULARIO
  criarVinculosDeParametrosMotivos :  '/duplicationform/criarvinculosdeparametrosmotivos/',

  //DUPLICAR VINCULO ENTRE PERGUNTAS X RESPOSTAS * PROCESSO DUPLICAR FORMULARIO
  criarVinculoPerguntaResposta :  '/duplicationform/criarVinculosEntrePerguntasRespostas/'

  
  

  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
